import { render, staticRenderFns } from "./wxhome.vue?vue&type=template&id=0148d756&scoped=true"
import script from "./wxhome.vue?vue&type=script&lang=js"
export * from "./wxhome.vue?vue&type=script&lang=js"
import style0 from "./wxhome.vue?vue&type=style&index=0&id=0148d756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0148d756",
  null
  
)

export default component.exports